/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import Loader from "../../../components/Loader/Index";
import { getRoles } from "../../../redux/features/Settings/Management/Roles";

import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import ICONS from "../../../assets/Icons";

export default function Roles() {
  const { allRolesData, allRolesIsLoading } = useSelector((x) => x.rolesSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [active, setActive] = useState("");
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[GlobalConfiguration.lengthCheckZero],
    });

  const [searchString, setSearchString] = useState(
    searchParam.get("search") || "",
  );
  const [sortValue, setSortValue] = useState(searchParam.get("sort") || "");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  useEffect(() => {
    (async () => {
      await dispatch(
        getRoles({
          page_no: currentPage,
          page_size: pageSize,
          search_string: searchString,
          sort_by:
            sortValue === "Alphabetical : A to Z"
              ? "ascending"
              : sortValue === "Alphabetical : Z to A"
                ? "descending"
                : sortValue === "Order : Latest"
                  ? "latest"
                  : sortValue === "Order : Oldest"
                    ? "oldest"
                    : "ascending",
        }),
      );
    })();
  }, [searchString, pageSize, currentPage, sortValue]);

  const roles = allRolesData?.roles ?? [];

  useEffect(() => {
    switch (active) {
      case "search":
      default:
      // setSearchString(searchText);
    }
  }, [active]);

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleClearParams = (e) => {
    handleClearSearchParam();

    if (showInnerSearchBar) return;
    setSearchString("");
    setSearchText("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  return false ? (
    <>
      <div className="fixed top-top-base left-left-base w-screen h-screen flex flex-col items-center justify-center z-z-index-loader">
        <div className="h-navbar-breadcrumb-height Qmd:block hidden"></div>
        <div>
          <Loader type={"bulk_upload"} />
        </div>
      </div>
    </>
  ) : (
    <div className="h-full-height flex flex-col overflow-y-hidden">
      {showInnerSearchBar && (
        <div className="roles-curtain-div h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"></div>
      )}
      <>
        {
          <div
            style={{
              zIndex: showInnerSearchBar
                ? "var(--z-index-max)"
                : "var(--z-index-max)",
              width: "var(--width-full)",
              bottom: "var(--bottom-base)",
            }}
            className="fixed w-full bg-primary-nav"
          >
            {showInnerSearchBar && (
              <div className="roles-curtain-div-page h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"></div>
            )}
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={allRolesData ?? []}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={(e) => {}}
            />
          </div>
        }
        <div className="relative z-z-index-overlay">
          <div className="h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav"></div>
          <TopNavComponent
            selectionBtnProps={{
              btnText: "Hello",
              btnType: "button",
              handleFunction: (e) => alert("hello"),
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              disabledTextColor: "",
              enabledBgColor: "var(--primary-bg)",
              disabledBgColor: null,
              isLoading: false,
              outLineColor: null,
              icon: ICONS?.EDIT,
            }}
            filteredSearchProps={{
              onSearchInput: (e) => setSearchText(e),
              searchInputRef: null,
              searchText: searchText,
              searchPlaceholder: "Search by role name/ role description",
              isSearchDisabled: false,
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchString,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchString(val);
                  },
                  isDropdown: false,
                  isDisabled: false,
                },
              ],
              filterPlaceholder: "role name/ role description",
              loading: false,
              inputData: [],
              setShowInnerSearchBar: setShowInnerSearchBar,
              setActive: setActive,
              isShowSortBy: true,
              filters: null,
              showSearchBar: false,
              isFilterClearAllDisabled: null,
              isSearchClearAllDisabled: null,
              // sortOption: sortOption,
              // sortHandleChange: (e) => {},
              sortByFilter: [
                {
                  name: "Alphabetical : A to Z",
                  default: true,
                },
                {
                  name: "Alphabetical : Z to A",
                },
                {
                  name: "Order : Latest",
                },
                {
                  name: "Order : Oldest",
                },
              ],
              // sortValue: null,
              // sortHandleChange: null,
              active: active,
              sortValue: sortValue,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setSortValue(val);
                setCurrentPage(GlobalConfiguration.lengthCheckOne);
              },
            }}
          />
        </div>
        {allRolesIsLoading ? (
          <>
            <div className="fixed top-top-base left-left-base w-screen h-screen flex flex-col items-center justify-center z-z-index-loader">
              <div className="h-navbar-breadcrumb-height Qmd:block hidden"></div>
              <div>
                <Loader type={"bulk_upload"} />
              </div>
            </div>
          </>
        ) : roles.length ? (
          <div
            className={`${showInnerSearchBar ? "overflow-hidden" : "overflow-y-scroll"} h-full mb-[var(--pagination-height)] scroll-py-top_md`}
          >
            <div
              className={`${showInnerSearchBar ? "overflow-y-hidden" : ""} flex-1  relative z-z-index-content`}
            >
              <div className="standard-card-alignment gap-y-gap-md gap-x-gap-sm overflow-y-visible">
                {roles.map(({ role_name, role_desc, role_id }) => {
                  return (
                    <CardContainer
                      cardBgColor="primary-card"
                      minHeight={"fit-content"}
                      context={role_id}
                      onClickHandler={(e, c) => {
                        const isViewAll = location.pathname.includes(
                          `settings/role_view_all`,
                        );

                        navigate(`role_detail_page/${c}`, {
                          state: { isViewAll },
                        });
                      }}
                    >
                      <card-body>
                        <TextWithIcon
                          text={role_name}
                          textColor="var(--text-primary)"
                          subText="Role name"
                        />
                        <TextWithIcon
                          text={role_desc}
                          textColor="var(--text-primary)"
                          subText="Role description"
                        />
                      </card-body>
                    </CardContainer>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              className={
                showInnerSearchBar
                  ? `h-height-full  opacity-dark-opacity flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                  : `flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl h-height-full gap-gap-sm ${
                      false ? "h-auto" : ""
                    }`
              }
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt="No accounts found"
                className={"w-graphic-width-md h-graphic-rectangle-height-md"}
              />
              <p className={"text-font-sm text-text-primary items-center"}>
                No data found.
              </p>
              <div
                style={{
                  display: searchString ? "flex" : "none",
                }}
              >
                <PrimaryButton
                  isDisabled={showInnerSearchBar}
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={handleClearParams}
                  buttonRef={null}
                  hoverOption="white"
                />
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
}
